export default {
  // Notifications
  async getNotifications(params = {}) {
    const query = new URLSearchParams(params).toString();
    return this.request(`/notifications${query ? '?' + query : ''}`);
  },

  async markNotificationRead(notificationId) {
    return this.request(`/notifications/${notificationId}/read`, { method: 'POST' });
  },

  async markAllNotificationsRead(params = {}) {
    // Scoped: marking everything read must mean the space you are looking at, not
    // whatever the server defaults to.
    const query = new URLSearchParams(params).toString();
    return this.request(`/notifications/mark-all-read${query ? '?' + query : ''}`, { method: 'POST' });
  },

  // Only a feed row addressed to you can be dismissed (the API answers 409 otherwise).
  async dismissNotification(notificationId) {
    return this.request(`/notifications/${notificationId}`, { method: 'DELETE' });
  },

  // Unread per lane for the space being looked at — the inbox's tab counts.
  async getNotificationCounts(params = {}) {
    const query = new URLSearchParams(params).toString();
    return this.request(`/notifications/counts${query ? '?' + query : ''}`);
  },

  // Activity Feed
  async getActivityStats() {
    return this.request('/activity-feed/stats');
  },
};
